import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((c) => {
  const s = localStorage.getItem("mapia_school");
  if (s) c.headers["X-School-Id"] = s;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(cfg);
      } catch (e) {
        /* falls through */
      }
    }
    throw err;
  }
);

export function formatDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg.replace("Value error, ", "") : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => formatDetail(e?.response?.data?.detail) || e?.message || "Algo deu errado. Tente novamente.";

export async function download(path, filename) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (e) {
    if (e.response?.data instanceof Blob) {
      const t = await e.response.data.text();
      try {
        throw new Error(formatDetail(JSON.parse(t).detail));
      } catch (x) {
        throw new Error(x.message || t);
      }
    }
    throw new Error(errMsg(e));
  }
}

export async function openBlob(path) {
  const w = window.open("", "_blank");
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  if (w) w.location.href = url;
  else window.location.href = url;
}
